'use client';

import * as React from 'react';
import {
  FileTextIcon,
  SendIcon,
  CheckCircleIcon,
  ClockIcon,
  RepeatIcon,
  BarChart3Icon
} from 'lucide-react';

import { BlurFade } from '~/components/fragments/blur-fade';
import { GridSection } from '~/components/fragments/grid-section';
import { SiteHeading } from '~/components/fragments/site-heading';

const FEATURES = [
  {
    icon: <FileTextIcon className="size-5 shrink-0" />,
    title: 'Professionele facturen',
    description:
      'Maak in seconden professionele facturen met je eigen branding. Kies uit verschillende templates en pas alles aan naar jouw wensen.'
  },
  {
    icon: <SendIcon className="size-5 shrink-0" />,
    title: 'Direct versturen',
    description:
      'Verstuur facturen direct per e-mail naar je klanten. Geen gedoe met PDF-bestanden of handmatige verzending – alles gaat automatisch.'
  },
  {
    icon: <CheckCircleIcon className="size-5 shrink-0" />,
    title: 'Betaalstatus bijhouden',
    description:
      'Houd precies bij welke facturen betaald zijn en welke nog openstaan. Zie in één oogopslag wat er nog binnen moet komen.'
  },
  {
    icon: <ClockIcon className="size-5 shrink-0" />,
    title: 'Automatische herinneringen',
    description:
      'Stel automatische herinneringen in voor openstaande facturen. Zo hoef je niet meer handmatig achter betalingen aan te zitten.'
  },
  {
    icon: <RepeatIcon className="size-5 shrink-0" />,
    title: 'Terugkerende facturen',
    description:
      'Stel automatisch terugkerende facturen in voor abonnementen of periodieke diensten. Emma verzendt ze automatisch op de juiste datum.'
  },
  {
    icon: <BarChart3Icon className="size-5 shrink-0" />,
    title: 'Financieel overzicht',
    description:
      'Krijg inzicht in je omzet, openstaande bedragen en betalingstermijnen. Alles wat je nodig hebt voor je financiële administratie.'
  }
];

export function FacturatieFeatures(): React.JSX.Element {
  return (
    <GridSection>
      <div className="container space-y-12 py-20 md:py-32">
        <SiteHeading
          badge="Unieke voordelen"
          title="Waarom Emma's facturatie anders is"
          description="Ontdek de krachtige functies die Emma biedt om je facturatieproces te stroomlijnen en sneller betaald te krijgen."
        />

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map((feature, index) => (
            <BlurFade
              key={index}
              inView
              delay={0.1 + index * 0.1}
              className="rounded-xl border bg-card p-6 shadow-sm transition-shadow hover:shadow-md"
            >
              <div className="mb-4 flex size-12 items-center justify-center rounded-xl border bg-background text-primary">
                {feature.icon}
              </div>
              <h3 className="mb-2 text-lg font-semibold">{feature.title}</h3>
              <p className="text-muted-foreground">{feature.description}</p>
            </BlurFade>
          ))}
        </div>
      </div>
    </GridSection>
  );
}
